import { render, staticRenderFns } from "./ProductDocument.vue?vue&type=template&id=f7b8cb90&"
import script from "./ProductDocument.vue?vue&type=script&lang=js&"
export * from "./ProductDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports